export const countryList = [
  {
    name: "sa",
    language: ["ar-SA", "en-SA"],
    translateLanguage: ["ar", "en"],
    companyName: "Venktron Electronics LLC",
    countryName: "Saudi Arabia ",
    address: "",
    flag: "",

  },
  {
    name: "ae",
    language: ["ar-AE", "en-AE"],
    translateLanguage: ["ar", "en"],
    companyName: "Shivas Scientific Supplies FZE",
    countryName: "United Arab Emirates ",
    address: "",
    flag: "",
  },
  {
    name: "me",
    language: ["ar", "en"],
    translateLanguage: ["ar", "en"],
    companyName: "Venktron Electronics LLC",
    countryName: "General Middle East ",
    address: "",
    flag: "",
  },

  {
    name: "bd",
    language: ["bn-BD"],
    translateLanguage: ["bn", "en"],
    companyName: "Active Machineries & Engineering Ltd",
    countryName: "Bangladesh ",
    address: "",
    flag: "",
  },
  {
    name: "lk",
    language: ["si-LK", "ta-LK", "en-LK"],
    translateLanguage: ["si", "ta", "en"],
    companyName: "Presto Group",
    countryName: "Sri Lanka ",
    address: "",
    flag: "",
  },
  {
    name: "ke",
    language: ["en-KE"],
    translateLanguage: ["en"],
    companyName: "DLA scientific Ltd",
    countryName: "Kenya ",
    address: "",
    flag: "",
  },
  {
    name: "tz",
    language: ["sw-TZ", "en-TZ"],
    translateLanguage: ["sw", "en"],
    companyName: "DLA scientific Ltd",
    countryName: "Tanzania ",
    address: "",
    flag: "",
  },
  {
    name: "ug",
    language: ["en-UG"],
    translateLanguage: ["en"],
    companyName: "DLA scientific Ltd",
    countryName: "Uganda ",
    address: "",
    flag: "",
  },
  {
    name: "ng",
    language: ["en-NG"],
    translateLanguage: ["en"],
    companyName: "Danbol Technologies Limited",
    countryName: "Nigeria ",
    address: "",
    flag: "",
  },
  {
    name: "gh",
    language: ["en-GH"],
    translateLanguage: ["en"],
    companyName: "Danbol Technologies Limited",
    countryName: "Ghana ",
    address: "",
    flag: "",
  },

  {
    name: "za",
    language: ["en-ZA", "af-ZA", "zu-ZA"],
    translateLanguage: ["en", "af", "zu"],
    companyName: "Presto Group",
    countryName: "South Africa ",
    address: "",
    flag: "",
  },
  {
    name: "zm",
    language: ["en-ZM"],
    translateLanguage: ["en"],
    companyName: "Presto Grouop",
    countryName: "Zambia ",
    address: "",
    flag: "",
  },
  {
    name: "vn",
    language: ["vi-VN"],
    translateLanguage: ["vi", "en"],
    companyName: "Presto Group",
    countryName: "Vietnam ",
    address: "",
    flag: "",
  },
  {
    name: "th",
    language: ["th-TH"],
    translateLanguage: ["th", "en"],
    companyName: " MAHAMONGKON ENGINEERING CO., LTD",
    countryName: "Thailand ",
    address: "",
    flag: "",
  },
  {
    name: "in",
    language: ["en-IN", "hi-IN"],
    translateLanguage: ["en", "hi"],
    companyName: "Prestro Group",
    countryName: "India ",
    address: "",
    flag: "",
  },
  {
    name: "np",
    language: ["en-NP", "ne-NP"],
    translateLanguage: ["en", "ne"],
    companyName: "Bizstop Concern",
    countryName: "Nepal ",
    address: "",
    flag: "https://www.prestogroup.com/assets/uploads/category-images/Nepal.png",
  },
  {
    name: "us",
    language: ["es-US", "en-US"],
    translateLanguage: ["en", "es"],
    companyName: "Prestro Group",
    countryName: "United State of America ",
    address: "",
    flag: "",
  },
];

export const companyLocation = [
  {
    name: "in",
    companyName: "Presto Group",
    countryName: "India",
    address: "",
    flag: "https://flagcdn.com/in.svg",
  },
  {
    name: "np",
    companyName: "Bizstop Concern",
    countryName: "Nepal",
    address: "",
    flag: "https://flagcdn.com/np.svg",
  },
  {
    name: "bh",
    companyName: "Shivas Scientific Supplies FZE",
    countryName: "Bahrain",
    address: "",
    flag: "https://flagcdn.com/bh.svg",
  },
  {
    name: "ir",
    companyName: "Venktron Electronics LLC",
    countryName: "Iran",
    address: "",
    flag: "https://flagcdn.com/ir.svg",
  },
  {
    name: "iq",
    companyName: "Venktron Electronics LLC",
    countryName: "Iraq",
    address: "",
    flag: "https://flagcdn.com/iq.svg",
  },
  {
    name: "il",
    companyName: "Venktron Electronics LLC",
    countryName: "Israel",
    address: "",
    flag: "https://flagcdn.com/il.svg",
  },
  {
    name: "ps",
    companyName: "Venktron Electronics LLC",
    countryName: "Occupied Palestinian Territories",
    address: "",
    flag: "https://flagcdn.com/ps.svg",
  },
  {
    name: "jo",
    companyName: "Venktron Electronics LLC",
    countryName: "Jordan",
    address: "",
    flag: "https://flagcdn.com/jo.svg",
  },
  {
    name: "kw",
    companyName: "Venktron Electronics LLC",
    countryName: "Kuwait",
    address: "",
    flag: "https://flagcdn.com/kw.svg",
  },
  {
    name: "lb",
    companyName: "Venktron Electronics LLC",
    countryName: "Lebanon",
    address: "",
    flag: "https://flagcdn.com/lb.svg",
  },
  {
    name: "om",
    companyName: "Shivas Scientific Supplies FZE",
    countryName: "Oman",
    address: "",
    flag: "https://flagcdn.com/om.svg",
  },
  {
    name: "qa",
    companyName: "Shivas Scientific Supplies FZE",
    countryName: "Qatar",
    address: "",
    flag: "https://flagcdn.com/qa.svg",
  },
  {
    name: "sa",
    companyName: "Techno Lab Solutions",
    countryName: "Saudi Arabia",
    address: "",
    flag: "https://flagcdn.com/sa.svg",
  },
  {
    name: "sy",
    companyName: "Venktron Electronics LLC",
    countryName: "Syria",
    address: "",
    flag: "https://flagcdn.com/sy.svg",
  },
  {
    name: "ae",
    companyName: "Venktron Electronics LLC",
    countryName: "United Arab Emirates",
    address: "",
    flag: "https://flagcdn.com/ae.svg",
  },
  {
    name: "ug",
    companyName: "DLA Scientific Ltd.",
    countryName: "Uganda",
    address: "",
    flag: "https://flagcdn.com/ug.svg",
  },
  {
    name: "tz",
    companyName: "DLA Scientific Ltd.",
    countryName: "Tanzania",
    address: "",
    flag: "https://flagcdn.com/tz.svg",
  },
  {
    name: "ke",
    companyName: "DLA Scientific Ltd.",
    countryName: "Kenya",
    address: "",
    flag: "https://flagcdn.com/ke.svg",
  },
  {
    name: "za",
    companyName: "Presto Group",
    countryName: "South Africa",
    address: "",
    flag: "https://flagcdn.com/za.svg",
  },
  {
    name: "zm",
    companyName: "Presto Group",
    countryName: "Zambia",
    address: "",
    flag: "https://flagcdn.com/zm.svg",
  },
  {
    name: "gh",
    companyName: "Danbol Technologies Limited",
    countryName: "Ghana",
    address: "",
    flag: "https://flagcdn.com/gh.svg",
  },
  {
    name: "ng",
    companyName: "Danbol Technologies Limited",
    countryName: "Nigeria",
    address: "",
    flag: "https://flagcdn.com/ng.svg",
  },
  {
    name: "tn",
    companyName: "Presto Group",
    countryName: "Tunisia",
    address: "",
    flag: "https://flagcdn.com/tn.svg",
  },
  {
    name: "lk",
    companyName: "Hemsons International Pvt Ltd",
    countryName: "Sri Lanka",
    address: "",
    flag: "https://flagcdn.com/lk.svg",
  },
  {
    name: "bd",
    companyName: "Active Machineries & Engineering Ltd.",
    countryName: "Bangladesh",
    address: "",
    flag: "https://flagcdn.com/bd.svg",
  },
  {
    name: "th",
    companyName: "MAHAMONGKON ENGINEERING CO., LTD.",
    countryName: "Thailand",
    address: "",
    flag: "https://flagcdn.com/th.svg",
  },
  {
    name: "vn",
    companyName: "Presto Group",
    countryName: "Vietnam",
    address: "",
    flag: "https://flagcdn.com/vn.svg",
  },
  {
    name: "de",
    companyName: "Presto Group",
    countryName: "Germany",
    address: "",
    flag: "https://flagcdn.com/de.svg",
  },
  {
    name: "gb",
    companyName: "Presto Group",
    countryName: "United Kingdom",
    address: "",
    flag: "https://flagcdn.com/gb.svg",
  },
  {
    name: "fr",
    companyName: "Presto Group",
    countryName: "France",
    address: "",
    flag: "https://flagcdn.com/fr.svg",
  },
  {
    name: "us",
    companyName: "Presto Group",
    countryName: "United States",
    address: "",
    flag: "https://flagcdn.com/us.svg",
  },
  {
    name: "ca",
    companyName: "Presto Group",
    countryName: "Canada",
    address: "",
    flag: "https://flagcdn.com/ca.svg",
  },
  {
    name: "sg",
    companyName: "Presto Group",
    countryName: "Singapore",
    address: "",
    flag: "https://flagcdn.com/sg.svg",
  },
  {
    name: "my",
    companyName: "Presto Group",
    countryName: "Malaysia",
    address: "",
    flag: "https://flagcdn.com/my.svg",
  },
  {
    name: "co",
    companyName: "SQS Labs S.A.S.",
    countryName: "Colombia",
    address: "",
    flag: "https://flagcdn.com/co.svg",
  },
  {
    name: "br",
    companyName: "Presto Group",
    countryName: "Brazil",
    address: "",
    flag: "https://flagcdn.com/br.svg",
  },
];
